
export const ru = {
  nav: {
    home: 'ГЛАВНАЯ',
    rsvp: 'ПОДТВЕРДИТЬ УЧАСТИЕ',
    details: 'ДЕТАЛИ',
    gallery: 'ГАЛЕРЕЯ',
    travel: 'ПУТЕШЕСТВИЕ',
    dressCode: 'ДРЕСС-КОД'
  },
  home: {
    invitation: 'ПРИГЛАШАЕМ ВАС\nРАЗДЕЛИТЬ С НАМИ\nДЕНЬ НАШЕЙ СВАДЬБЫ',
    coupleNames: 'ПОЛИНА & ЕВГЕНИЙ',
    date: '07.09.2026',
    dateRange: '6-8 сентября 2026',
    location: 'Talici Hill, Черногория',
    locationLabel: 'МЕСТО ПРОВЕДЕНИЯ',
    venueName: 'Talici Hill',
    venueLocation: 'Черногория',
    countdown: 'До церемонии осталось',
    days: 'ДНЕЙ',
    hours: 'ЧАСОВ',
    minutes: 'МИНУТ',
    seconds: 'СЕКУНД',
    rsvpButton: 'Подтвердить участие',
    rsvpSubtext: 'Пожалуйста, сообщите, сможете ли вы быть с нами',
    addToCalendar: 'Добавить в календарь'
  },
  rsvp: {
    title: 'Подтверждение участия',
    subtitle: 'Пожалуйста, ответьте на несколько вопросов, чтобы мы могли лучше подготовиться к встрече с вами',
    guestInfo: 'Информация о госте',
    firstName: 'Имя',
    lastName: 'Фамилия',
    email: 'Email',
    phone: 'Номер телефона',
    attendance: 'Сможете ли вы присутствовать?',
    attendingYes: 'С удовольствием приду',
    attendingNo: 'К сожалению, не смогу',
    whichDays: 'В какие дни вы будете с нами?',
    day1: '6 сентября (Приветственный ужин)',
    day2: '7 сентября (День свадьбы)',
    day3: '8 сентября (Прощальный бранч)',
    selectOneDay: '* Пожалуйста, выберите хотя бы один день',
    addGuest: '+ Добавить гостя',
    addGuestNote: 'Нажмите, чтобы добавить еще одного гостя в ваше подтверждение',
    guestNumber: 'Гость',
    information: 'Информация',
    remove: 'Удалить',
    bringingKids: 'Я буду с детьми',
    numberOfKids: 'Количество детей',
    dietary: 'Пищевые предпочтения и аллергии',
    dietaryNone: 'Нет ограничений',
    dietaryVegetarian: 'Вегетарианец',
    dietaryVegan: 'Веган',
    dietaryGlutenFree: 'Без глютена',
    dietaryOther: 'Другое',
    dietaryDetails: 'Пожалуйста, уточните детали',
    message: 'Пожелание паре',
    submit: 'Отправить ответ',
    submitting: 'Отправка...',
    thankYou: 'Спасибо!',
    successMessage: 'Ваша форма успешно отправлена.',
    successMessage2: 'Мы получили ваш ответ и с нетерпением ждем встречи!',
    confirmationEmail: 'Мы отправим подтверждение на указанный вами email.'
  },
  schedule: {
    title: 'Три дня торжества',
    subtitle: 'Приглашаем вас провести незабываемые выходные в Черногории',
    day1Title: 'Приветственный ужин',
    day2Title: 'Свадебная церемония',
    day3Title: 'Прощальный бранч',
    time: 'Время',
    location: 'Место',
    dates: {
      day1: '6 сентября',
      day2: '7 сентября',
      day3: '8 сентября'
    },
    events: {
      day1: {
        event1: {
          title: 'Прибытие',
          description: 'Добро пожаловать в Talici Hill! Пожалуйста, располагайтесь и заезжайте в свои номера.',
          location: 'Ресепшн Talici Hill'
        },
        event2: {
          title: 'Начало ужина',
          description: 'Уютный вечер в кругу друзей и близких, чтобы начать наше празднование.',
          location: 'Сад Talici Hill'
        },
        event3: {
          title: 'Завершение вечера',
          description: 'Время отдохнуть и набраться сил перед главным днем.',
          location: 'Сад Talici Hill'
        }
      },
      day2: {
        event1: {
          title: 'Приветственные напитки',
          description: 'Легкие напитки и общение перед началом церемонии.',
          location: 'Ресепшн Talici Hill'
        },
        event2: {
          title: 'Фотосессия',
          description: 'Профессиональная съемка с парой и гостями.',
          location: 'Церемониальный сад'
        },
        event3: {
          title: 'Церемония',
          description: 'Наши клятвы на фоне панорамы Адриатического моря.',
          location: 'Церемониальный сад'
        },
        event4: {
          title: 'Аперитив',
          description: 'Шампанское, закуски и закат.',
          location: 'Зона ужина'
        },
        event5: {
          title: 'Свадебный ужин',
          description: 'Торжественный ужин с блюдами местной кухни.',
          location: 'Зона ужина'
        },
        event6: {
          title: 'Свадебный торт',
          description: 'Торжественное разрезание торта.',
          location: 'Зона ужина'
        },
        event7: {
          title: 'Afterparty',
          description: 'Танцы под открытым небом Черногории.',
          location: 'Зона ужина'
        }
      },
      day3: {
        event1: {
          title: 'Pool Party & Пицца',
          description: 'Расслабленный отдых у бассейна с вкусной пиццей в завершение праздника.',
          location: 'Зона бассейна Talici Hill'
        }
      }
    },
    dressCode: {
      title: 'Дресс-код',
      intro: 'Мы очень рады, что вы разделите с нами этот праздник! Чтобы вам было комфортнее подготовиться к поездке в Черногорию, мы составили небольшие рекомендации по стилю.',
      sunday: 'Воскресенье, 6 сентября: Приветственный ужин',
      sundayDesc: 'Начнем выходные с неформального барбекю-ужина.',
      sundayCode: 'Дресс-код: Smart-Casual / Casual',
      monday: 'Понедельник, 7 сентября: День свадьбы',
      mondayDesc: 'Наша церемония пройдет на открытом воздухе с видом на Средиземное море и горы Черногории.',
      mondayCode: 'Дресс-код: Summer Outdoor Black Tie',
      mondayNote: '(Мы будем рады, если вы нарядитесь и поддержите праздничную атмосферу!)',
      ladies: 'Дамы:',
      ladiesDesc: 'Мы сохраняем элегантную вечернюю атмосферу, но строгое правило "обязательно в пол" отменяется! Пожалуйста, выбирайте элегантные ткани с подолом от середины икры до пола (цветные платья по-прежнему очень приветствуются!). Завершите образ любимыми туфлями на каблуке или нарядными босоножками.',
      gentlemen: 'Мужчины:',
      gentlemenDesc: 'Черный смокинг (или традиционный килт, если уместно). Если смокинга нет, классический черный костюм станет отличной альтернативой.',
      tuxedoNote: '* Примечание: смокинг можно взять в аренду по доступной цене.',
      tuesday: 'Вторник, 8 сентября: Бранч у бассейна',
      tuesdayDesc: 'Пляжная вечеринка, легкая и удобная одежда. Не забудьте купальники, чтобы насладиться бассейном!',
      tuesdayCode: 'Дресс-код: Casual / Пляжный стиль',
      viewGallery: 'Посмотреть галерею образов →',
      galleryNote: 'Мы подготовили подборку образов для вашего вдохновения',
      closing: 'С нетерпением ждем встречи! Если у вас есть вопросы, обязательно пишите нам.',
      detailTitle: 'Дорогие гости! 🤍',
      detailIntro: 'Мы получили довольно много вопросов относительно дресс-кода, поэтому хотим все прояснить и сделать подготовку к нашему особенному дню максимально простой для вас!',
      detailTheme: 'Наша тема — Летний Шикарный Черный Галстук (Summer-Chic Black Tie). Поскольку это лето, мы смягчили строгие традиционные правила для всех! Однако, пожалуйста, помните о самом важном задании вечера: выглядеть абсолютно потрясающе, гламурно и затмить всех вокруг! 😉',
      detailGuidelines: 'Чтобы помочь вам создать свои образы, вот наши простые рекомендации:',
      detailColorPalette: '✨ Цветовая палитра: Мы приветствуем абсолютно любые цвета и оттенки — от нежных пастельных до ярких, сочных летних тонов. Даже ярко-красное платье абсолютно разрешено и приветствуется! Мы только просим дам избегать двух конкретных цветов: белого (зарезервирован для невесты) и черного (давайте сохраним наше лето красочным и веселым!). Это правило распространяется только на дам.',
      detailLadies: '👗 Для дам: Строгое требование "обязательно длина в пол" снято, но мы определенно сохраняем вечернюю атмосферу. Длина вашего платья должна быть от середины икры до пола. Выбирайте элегантные ткани. И, конечно же, не забудьте свои любимые туфли на каблуках или нарядные босоножки.',
      detailGentlemen: '👔 Для мужчин: Мы также снизили строгость для мужчин! Классический смокинг или просто очень элегантный черный костюм с белой рубашкой — идеальный выбор. Бабочка или классический галстук на этот раз необязательны, но мы будем ОЧЕНЬ рады их увидеть! Давайте вместе добавим эту особенную нотку элегантности. 🤍',
      detailFlexibility: 'Конечно, если у вас все еще есть вопросы или вы считаете абсолютно невозможным идеально соответствовать дресс-коду — пожалуйста, не волнуйтесь, никто не собирается вас выгонять! Самое важное для нас — это чтобы вы были с нами, ваши улыбки, ваша лучезарная энергия и ваш комфорт.',
      detailClosing: 'Мы не можем дождаться, чтобы отпраздновать с вами!'
    },
    weather: {
      title: 'Прогноз погоды',
      subtitle: 'Сентябрь в Черногории'
    },
    venue: {
      title: 'Место проведения',
      getDirections: 'Проложить маршрут',
      visitWebsite: 'Сайт площадки'
    }
  },
  gallery: {
    title: 'Галерея',
    subtitle: 'Talici Hill, Черногория',
    dressCode: 'Вдохновение для дресс-кода',
    dressCodeSubtitle: 'Образы для нашего праздника в стиле Summer Outdoor Black Tie'
  },
  whatsapp: {
    joinChannel: 'Присоединяйтесь к нашему каналу WhatsApp для всех обновлений',
    joinGroup: 'Присоединяйтесь к нашей группе WhatsApp'
  },
  telegram: {
    joinGroup: 'Присоединяйтесь к нашей группе Telegram'
  },
  travel: {
    title: 'Путешествие и проживание',
    subtitle: 'Все, что вам нужно знать о поездке в Черногорию',
    accommodation: {
      title: 'Где остановиться',
      recommendation: 'Варианты проживания',
      description: 'Рядом с Talici Hill есть множество вариантов размещения, включая отели и апартаменты (например, Apartments Villa Mare Mar) или аренду вилл.',
      groupTip: 'Совет: Рассмотрите аренду виллы вместе',
      groupDescription: 'Если вы выберете аренду виллы, подумайте о координации с другими гостями для совместной аренды виллы с 4-5 спальнями. Вы получите больше пространства, частный бассейн и лучший опыт в целом.',
      whatsappPrompt: 'Используйте наш WhatsApp канал, чтобы связаться с другими гостями и организовать проживание!'
    },
    gettingThere: {
      title: 'Как добраться',
      airport: 'Ближайшие аэропорты',
      airportTivat: 'Аэропорт Тивата (TIV)',
      airportPodgorica: 'Аэропорт Подгорицы (TGD)',
      airportDubrovnik: 'Аэропорт Дубровника (DBV, Хорватия)',
      transport: 'Варианты транспорта',
      carRental: 'Аренда автомобиля - Рекомендуется для гибкости',
      taxi: 'Такси/Трансфер - Доступно из всех аэропортов',
      rideshare: 'Приложения для заказа поездок доступны в Черногории'
    },
    localInfo: {
      title: 'Местная информация',
      currency: 'Валюта: Евро (€)',
      language: 'Язык: Черногорский (английский широко распространен в туристических зонах)',
      weather: 'Погода в сентябре: Тепло и солнечно, 20-28°C',
      whatToPack: 'Что взять с собой: Купальник, солнцезащитный крем, удобную обувь и танцевальный наряд!'
    }
  },
  travelForm: {
    title: 'Анкета гостя',
    intro1: 'Дорогие гости!',
    intro2: 'Пожалуйста, ответьте на несколько вопросов ниже, чтобы мы могли сделать ваше пребывание на нашей свадьбе в Черногории максимально комфортным и приятным.',
    intro3: 'Спасибо! С нетерпением ждем встречи с вами!',
    person: 'Гость',
    selectName: 'Ваше имя',
    selectNamePlaceholder: 'Выберите ваше имя из списка гостей...',
    selectNameNote: 'Не нашли свое имя? Свяжитесь с нами.',
    personalInfo: 'Личная информация',
    phone: 'Контактный номер (Telegram / WhatsApp)',
    travelDetails: 'Перелет и поездка',
    travelModeQ: 'Как вы добираетесь?',
    travelModeFlight: 'Самолетом',
    travelModeOther: 'Другое (машина, поезд...)',
    arrivalDay: 'День приезда',
    airport: 'Аэропорт',
    airportTivat: 'Тиват',
    airportPodgorica: 'Подгорица',
    airportOther: 'Другой',
    airportOtherPlaceholder: 'Пожалуйста, укажите аэропорт',
    arrival: 'Прилет',
    departure: 'Вылет',
    date: 'Дата',
    pickDate: 'Выберите дату',
    time: 'Время',
    flight: 'Авиакомпания и номер рейса',
    flightPlaceholder: 'например, Air Serbia JU662',
    transferArrivalQ: 'Нужен ли вам трансфер аэропорт → отель по прилете?',
    transferDepartureQ: 'Нужен ли вам трансфер отель → аэропорт в день вылета?',
    transferYes: 'Да',
    transferNo: 'Нет, организую самостоятельно',
    transferOther: 'Другое',
    transferOtherPlaceholder: 'Пожалуйста, уточните',
    accommodation: 'Проживание',
    hotelQ: 'В каком отеле вы будете проживать?',
    hotelPlaceholder: 'Название отеля',
    menuTitle: 'Меню · 7 сентября',
    coldAppetizerQ: 'Холодная закуска',
    coldMontenegrin: 'Традиционная черногорская закуска (негушский пршут, домашний сыр, копченый сыр, сыр с зеленью, оливки)',
    coldSalmon: 'Тартар из лосося с авокадо и маринованной кольраби',
    coldVegan: 'Веганский вариант: салат из киноа с вялеными томатами, авокадо и семечками подсолнуха',
    mainCourseQ: 'Основное блюдо',
    mainMonkfish: 'Филе морского чёрта с шафрановым ризотто и микрозеленью',
    mainBeef: 'Медальоны из говядины с обжаренными овощами и пюре из сельдерея',
    mainVegan: 'Веганский вариант: тофу на гриле с овощами и соусом из инжира',
    allergiesQ: 'Аллергии или особенности питания',
    allergyLactose: 'Лактоза',
    allergyGluten: 'Глютен',
    allergyCitrus: 'Цитрусовые',
    allergyNuts: 'Орехи',
    allergyRedFruits: 'Красные фрукты и овощи',
    allergyOther: 'Другое',
    allergyOtherPlaceholder: 'Пожалуйста, уточните',
    flowerAllergyNote: '* Если у вас есть аллергия на цветы, пожалуйста, также сообщите нам об этом.',
    drinksTitle: 'Напитки',
    drinksQ: 'Предпочтения по напиткам',
    drinkWhiteWine: 'Белое вино',
    drinkRedWine: 'Красное вино',
    drinkRose: 'Розовое вино',
    drinkSparkling: 'Игристое вино',
    drinkBeer: 'Пиво',
    drinkRakija: 'Местная ракия',
    drinkVodka: 'Водка',
    drinkGin: 'Джин',
    drinkWhisky: 'Виски',
    drinkRum: 'Ром',
    drinkTequila: 'Текила',
    childrenTitle: 'Для гостей с детьми',
    childQ: 'Планируете ли вы приехать с ребенком? Если да, пожалуйста, сообщите, можем ли мы сделать что-нибудь, чтобы ваше пребывание было более комфортным.',
    childPlaceholder: 'Ваш ответ (необязательно)',
    beautyTitle: 'Услуги стилистов',
    beautyQ: 'В день свадьбы в отеле будут стилисты — хотите записаться?',
    beautyMakeup: 'Макияж — стоимость уточняется',
    beautyHair: 'Прическа — стоимость уточняется',
    beautyFullLook: 'Полный образ (макияж + прическа) — стоимость уточняется',
    beautyNone: 'Не потребуется, спасибо',
    anythingElse: 'Что-нибудь еще?',
    commentsQ: 'Что-нибудь еще? Вопросы, пожелания, комментарии',
    commentsPlaceholder: 'Ваш ответ (необязательно)',
    addPerson: '+ Добавить гостя',
    addPersonNote: 'Заполняете анкету за семью или друзей? Добавьте их здесь.',
    removePerson: 'Удалить',
    whoSection: 'Выберите гостей',
    addChild: '+ Добавить ребенка',
    addChildNote: 'Для детей предусмотрено отдельное меню.',
    childLabel: 'Ребенок',
    childName: 'Имя и фамилия ребенка',
    childNamePlaceholder: 'например, Анна Смирнова',
    sameTravel: 'Та же информация о поездке, что и у',
    detailsFor: 'Анкета для',
    flightFor: 'Перелет и поездка для',
    kidsMenuTitle: 'Детское меню · 7 сентября',
    kidsAppetizerQ: 'Закуска',
    kidsAppPastaCheese: 'Паста с сыром',
    kidsAppPastaNapolitan: 'Паста Наполитан',
    kidsAppMozzarella: 'Хрустящие палочки моцареллы',
    kidsMainQ: 'Основное блюдо',
    kidsMainNuggets: 'Куриные наггетсы с картофелем фри',
    kidsMainChicken: 'Куриное филе с картофельным пюре',
    kidsMainBurger: 'Бургер с картофелем фри',
    submit: 'Отправить',
    submitting: 'Отправка...',
    errorSelectName: 'Пожалуйста, выберите имя для каждого гостя',
    errorChildName: 'Пожалуйста, укажите имя ребенка',
    errorRequired: 'Пожалуйста, заполните все обязательные поля для',
    thankYou: 'Спасибо!',
    successMessage: 'Ваша анкета успешно отправлена. Мы с нетерпением ждем встречи с вами!',
    allSubmitted: 'Похоже, все гости уже заполнили анкету. Спасибо!',
    alreadySubmittedTag: 'анкета уже заполнена',
    alreadySubmittedTitle: 'Анкета уже заполнена',
    alreadySubmittedIntro: 'Мы уже получили анкету для гостя',
    alreadySubmittedContact: 'Если нужно что-то изменить или дополнить, пожалуйста, свяжитесь напрямую с Полиной или Евгением — мы с радостью поможем.',
    alreadySubmittedOk: 'Понятно',
    loadError: 'Не удалось загрузить список гостей. Пожалуйста, обновите страницу.'
  }
};


